import React, { FunctionComponent } from "react"
import "./EALABrokenRecord.css"

const EALABrokenRecord: FunctionComponent<{}> = () => {
    return (
        <div className="EALABrokenRecord">
            <div className="EALABrokenRecordHeader">
                <p>There is an issue with this employees record.</p>
            </div>
            <div className="EALABrokenRecordBody">
            <span className="material-icons">sync_problem</span>
            </div>
        </div>
    )
}

export default EALABrokenRecord